module.exports = __webpack_public_path__ + "img/register-icon-03.00c7b936.png";